export default __webpack_public_path__ + "static/studycafe-firenze3-743501adfcca79b4f9de83901d404921.jpg";